import { useEntryValuesStore } from "@/features/inputs/hooks/useEntryValuesStore";
import { useFormNavigationStore } from "@/features/pages/hooks/useFormNavigationStore";
import { parseScreenerSearch } from "@/features/screeners/utils/screenerSearch";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

// Screeners have no cover page: the link starts a new attempt and opens page 1 straight away.
// Done here rather than in beforeLoad, which also runs when a link to this route is preloaded on hover.
const ScreenerStart = () => {
    const { screenerId } = Route.useParams();
    const search = Route.useSearch();
    const navigate = useNavigate();
    const started = useRef(false);

    useEffect(() => {
        if (started.current) return;
        started.current = true;
        useEntryValuesStore.getState().resetEntryValues();
        // Each attempt gets its own id, so answers from an earlier go are never carried over.
        const entryId = crypto.randomUUID();
        useFormNavigationStore.getState().resetHistory(entryId);
        void navigate({
            to: "/screen/$screenerId/$entryId/page/$pageIndex",
            params: { screenerId, entryId, pageIndex: "1" },
            search,
            replace: true,
        });
    }, [navigate, screenerId, search]);

    return null;
};

export const Route = createFileRoute("/screen/$screenerId/")({
    component: ScreenerStart,
    validateSearch: parseScreenerSearch,
});
